import { TDate } from '@monorepo/types';
import moment from 'moment';

export const DISPLAY_PIPE_DATE_FORMAT = 'dd-MM-yyyy';

export class DateUtils {
  //example: Tue 19 Dec 2023
  static fullDateFormat() {
    const day = moment();
    return `${day.format('ddd')} ${day.format('DD')} ${day.format('MMM')} ${day.format('YYYY')}`;
  }

  //example 13:45 -> 1:45pm
  static getTimeformatte(time: string) {
    const parsedTime = moment(time, 'HH:mm');
    const formattedTime = parsedTime.format('h:mma');
    return formattedTime;
  }

  // get current date //
  static getCrntDate() {
    const day = moment();
    return day.format('YYYY-MM-DD');
  }

  //Here datestring is of format YYYY-MM-DD as sent by backend
  static getDateFromDateString = (dateString: string) => {
    return new Date(dateString);
  };

  //Here datestring is of format YYYY-MM-DD as sent by backend
  static getDateStringFromDate = (date: number | Date | string): TDate => {
    return moment(date).format('YYYY-MM-DD') as TDate;
  };

  static getDisplayDateStringFromDate = (date: number | Date | string) => {
    return moment(date).format('DD-MM-YYYY');
  };

  static getFirstDateOfMonthFromDate = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return this.getDateStringFromDate(new Date(year, month).valueOf());
  };

  static getLastDateOfMonthFromDate = (date: number | Date) => {
    const date$ = new Date(date);
    const year = date$.getFullYear();
    const month = date$.getMonth();
    return this.getDateStringFromDate(new Date(year, month + 1, 0).valueOf());
  };

  //takes two YYYY-MM-DD strings and returns one between them YYYY-MM-DD
  static generateRandomDate = (startDate: string, endDate: string): string => {
    const firstDate = new Date(startDate);
    const lastDate = new Date(endDate);
    const timeDiff = lastDate.getTime() - firstDate.getTime();
    const randomTime = Math.random() * timeDiff;
    const randomDate = new Date(firstDate.getTime() + randomTime);
    return DateUtils.getDateStringFromDate(randomDate);
  };

  /**
   * Checks whether a given date string falls within the past N days (inclusive).
   *
   * @param date - The input date string (ISO format or any format parsable by Moment).
   * @param numOfDays - The number of days to look back from today.
   * @returns `true` if the date is within the past `numOfDays` (including today), `false` otherwise.
   *
   * @example
   * isDateWithinPastDays('2025-07-01', 3) // returns true if today is between July 1 and July 3, 2025
   */
  static isDateWithinPastDays(date: string, numOfDays: number): boolean {
    const today = moment();
    const selected = moment.parseZone(date);
    const fromDate = today.clone().subtract(numOfDays, 'days');

    return selected.isSameOrAfter(fromDate, 'day') && selected.isSameOrBefore(today, 'day');
  }
}
